














































import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class Aside extends Vue {
  @Prop() private msg!: string;

  reset() {
    (this.$refs.menu as any).activeIndex = ""
  }

  jump() {
    const routeUrl = this.$router.resolve({
      path: "/doc",
      query: {}
    });
    window.open(routeUrl .href, '_blank');
  }
}
